import { ReactNode } from "react";
import { useAuth } from "@/hooks/useAuth";
import SuspendedOverlay from "./SuspendedOverlay";

interface SuspendedGuardProps {
    children: ReactNode;
}

const SuspendedGuard = ({ children }: SuspendedGuardProps) => {
    const { isSuspended, user } = useAuth();

    // Only show suspended overlay if user is logged in and suspended
    if (user && isSuspended) {
        return <SuspendedOverlay />;
    }

    return <>{children}</>;
};

export default SuspendedGuard;
